(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["test-block"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.mmSizeChartModalInitialized) return;
    window.mmSizeChartModalInitialized = true;

    var scrollPosition = 0;

    function lockPageScroll() {
      scrollPosition = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockPageScroll() {
      if (document.querySelector('.mm-size-chart__modal[open]')) return;

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-mm-size-chart-open]');
      var closeTrigger = event.target.closest('[data-mm-size-chart-close]');

      if (openTrigger) {
        var modal = document.getElementById(openTrigger.getAttribute('data-mm-size-chart-open'));
        if (modal) {
          modal.showModal();
          lockPageScroll();
        }
      }

      if (closeTrigger) {
        var modalToClose = document.getElementById(closeTrigger.getAttribute('data-mm-size-chart-close'));
        if (modalToClose) modalToClose.close();
      }
    });

    document.querySelectorAll('.mm-size-chart__modal').forEach(function (dialog) {
      dialog.addEventListener('close', unlockPageScroll);

      dialog.addEventListener('click', function (e) {
        var rect = dialog.getBoundingClientRect();
        var clickedInDialog =
          rect.top <= e.clientY && e.clientY <= rect.bottom &&
          rect.left <= e.clientX && e.clientX <= rect.right;
        if (!clickedInDialog) dialog.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
